var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ys-data-table", {
        ref: "tableData",
        attrs: {
          list: _vm.searchList,
          "fetch-method": _vm.fetchMethod,
          columns: _vm.columns,
          "transform-params": _vm.handleTransformParams,
          "dep-option-map": _vm.optionsMap,
          "page-alias": "p",
          "page-size-alias": "psize",
          "use-data-field": "",
          "max-height": "600"
        },
        on: {
          "selection-change": _vm.handleSelectionChange,
          "on-fetch-success": _vm.handleFetchSuccess,
          "on-change": _vm.handleParamsChange
        },
        scopedSlots: _vm._u([
          {
            key: "table-title",
            fn: function() {
              return [
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "end" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleMultipleEdit }
                      },
                      [_vm._v("\n          批量修改\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "small" },
                        on: { click: _vm.handleMultipleRecover }
                      },
                      [_vm._v("\n          批量导入恢复正常\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleRecoverNormal }
                      },
                      [_vm._v("\n          恢复正常\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleMultipleApplyDeficit }
                      },
                      [_vm._v("\n          批量申请盘亏\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleCompensateClick }
                      },
                      [_vm._v("\n          申请赔付\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "small" },
                        on: { click: _vm.handleExport }
                      },
                      [_vm._v("\n          导出\n        ")]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "dbid",
            fn: function(ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.openQrCode("dbid=" + row.dbid)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(row.dbid) + "\n      ")]
                )
              ]
            }
          },
          {
            key: "goods_img",
            fn: function(ref) {
              var row = ref.row
              return [
                row.goods_img[0]
                  ? _c("img", {
                      staticStyle: {
                        width: "60px",
                        height: "60px",
                        "object-fit": "cover"
                      },
                      attrs: { src: row.goods_img[0], alt: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleViewImage(row.goods_img)
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var row = ref.row
              var index = ref.index
              return [
                row.status === _vm.constantMap.isException
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleEdit(row, index)
                          }
                        }
                      },
                      [_vm._v("\n        编辑\n      ")]
                    )
                  : _vm._e()
              ]
            }
          }
        ]),
        model: {
          value: _vm.refresh,
          callback: function($$v) {
            _vm.refresh = $$v
          },
          expression: "refresh"
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleMultipleEdit,
            "close-on-click-modal": false,
            title: "批量修改"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleMultipleEdit = $event
            },
            close: _vm.handleMultipleEditClose
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visibleMultipleEdit = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirmMultipleEdit }
                    },
                    [_vm._v("\n        确认\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            { ref: "formMultipleEdit", attrs: { model: _vm.formMultipleEdit } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "excel" } },
                [
                  _c("ys-upload-combo", {
                    attrs: {
                      "download-temp": _vm.handleDownloadEditTemp,
                      "btn-upload": "选择文件",
                      "btn-list": ""
                    },
                    model: {
                      value: _vm.formMultipleEdit.excel,
                      callback: function($$v) {
                        _vm.$set(_vm.formMultipleEdit, "excel", $$v)
                      },
                      expression: "formMultipleEdit.excel"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [_vm._v("请先下载模版，与模版一样格式")]),
              _vm._v(" "),
              _c("div", { staticStyle: { color: "#fb0825" } }, [
                _vm._v(
                  "\n        注意：若为第三方理赔，第三方责任部门为必填项\n      "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleApplyDeficit,
            "close-on-click-modal": false,
            title: "批量申请盘亏"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleApplyDeficit = $event
            },
            close: _vm.handleApplyDeficitClose
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visibleApplyDeficit = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirmMultipleApplyDeficit }
                    },
                    [_vm._v("\n        确认\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            { ref: "formApplyDeficit", attrs: { model: _vm.formApplyDeficit } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "excel" } },
                [
                  _c("ys-upload-combo", {
                    attrs: {
                      "download-temp": _vm.handleDownloadDeficitTemp,
                      "btn-upload": "选择文件",
                      "btn-list": ""
                    },
                    model: {
                      value: _vm.formApplyDeficit.excel,
                      callback: function($$v) {
                        _vm.$set(_vm.formApplyDeficit, "excel", $$v)
                      },
                      expression: "formApplyDeficit.excel"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [_vm._v("请先下载模版，与模版一样格式")]),
              _vm._v(" "),
              _c("div", { staticStyle: { color: "#fb0825" } }, [
                _vm._v(
                  "\n        注意：若为第三方理赔，第三方责任部门为必填项\n      "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleMultipleRecover,
            "close-on-click-modal": false,
            title: "批量导入恢复正常"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleMultipleRecover = $event
            },
            close: _vm.handleMultipleRecoverClose
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visibleMultipleRecover = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirmMultipleRecover }
                    },
                    [_vm._v("\n        确认\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "formMultipleRecover",
              attrs: { model: _vm.formMultipleRecover }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "excel" } },
                [
                  _c("ys-upload-combo", {
                    attrs: {
                      "download-temp": _vm.handleDownloadRecoverTemp,
                      "btn-upload": "选择文件",
                      "btn-list": ""
                    },
                    model: {
                      value: _vm.formMultipleRecover.excel,
                      callback: function($$v) {
                        _vm.$set(_vm.formMultipleRecover, "excel", $$v)
                      },
                      expression: "formMultipleRecover.excel"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "请先下载模版，与模版一样格式，并且确保每行数据正确，不能为空"
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleEdit,
            "close-on-click-modal": false,
            width: "600px",
            title: "编辑"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleEdit = $event
            },
            close: _vm.handleEditClose
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visibleEdit = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirmEdit }
                    },
                    [_vm._v(" 确认 ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "formEdit",
              attrs: { model: _vm.formEdit, "label-width": "80px" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "异常原因",
                    prop: "cause_id",
                    rules: _vm.rules.ruleChange
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.formEdit.cause_id,
                        callback: function($$v) {
                          _vm.$set(_vm.formEdit, "cause_id", $$v)
                        },
                        expression: "formEdit.cause_id"
                      }
                    },
                    [
                      _vm._l(_vm.oldOptionsMap.reasonList, function(item) {
                        return _c("el-option", {
                          key: item.rdid,
                          attrs: { label: item.rdname, value: "" + item.rdid }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.optionsMap.reasonList, function(item) {
                        return _c("el-option", {
                          key: item.rdid,
                          attrs: { label: item.rdname, value: "" + item.rdid }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "责任部门", prop: "rd_id" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.optionsMap.departmentList,
                      props: { checkStrictly: true }
                    },
                    model: {
                      value: _vm.formEdit.rd_id,
                      callback: function($$v) {
                        _vm.$set(_vm.formEdit, "rd_id", $$v)
                      },
                      expression: "formEdit.rd_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "责任人", prop: "r_personnel" } },
                [
                  _c("ys-input", {
                    attrs: { maxlength: _vm.constantMap.maxName },
                    model: {
                      value: _vm.formEdit.r_personnel,
                      callback: function($$v) {
                        _vm.$set(_vm.formEdit, "r_personnel", $$v)
                      },
                      expression: "formEdit.r_personnel"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26ea76fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ea76fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/StockDetailErrorDetail.vue
// module id = null
// module chunks = 